/** Matches construction-plan-analysis skill output (see api ChatHtmlReportDetector). */
export function isHtmlReport(text: string | undefined | null): boolean {
  if (!text) return false;
  const trimmed = text.trimStart();
  if (trimmed.toLowerCase().startsWith('<style')) return true;
  if (trimmed.includes('class="wrap"') || trimmed.includes("class='wrap'")) return true;
  const styleIdx = text.search(/<style\b/i);
  if (styleIdx >= 0) {
    const tail = text.slice(styleIdx);
    return tail.includes('class="wrap"') || tail.includes("class='wrap'");
  }
  return false;
}

/** Extract renderable HTML from text (fences, preamble, or inline). */
export function extractHtmlFromText(text: string | undefined | null): string | null {
  if (!text) return null;
  if (isHtmlReport(text) && text.trimStart().toLowerCase().startsWith('<style')) {
    return text.trim();
  }
  const fence = /```html\s*([\s\S]*?)```/i.exec(text);
  if (fence?.[1] && isHtmlReport(fence[1])) return fence[1].trim();
  const styleIdx = text.search(/<style\b/i);
  if (styleIdx >= 0) {
    const candidate = text.slice(styleIdx).trim();
    if (isHtmlReport(candidate)) return candidate;
  }
  return isHtmlReport(text) ? text.trim() : null;
}

export const CHAT_MODEL_HAIKU = 'claude-haiku-4-5';
export const CHAT_MODEL_SONNET = 'claude-sonnet-4-5';
export const CHAT_MODEL_DEFAULT = CHAT_MODEL_HAIKU;

export const CHAT_MODEL_OPTIONS = [
  { id: CHAT_MODEL_HAIKU, label: 'Haiku', hint: 'Lower cost, faster' },
  { id: CHAT_MODEL_SONNET, label: 'Sonnet', hint: 'Higher quality' },
] as const;
